(function () {
  'use strict';

  if (window.__jrbMinimalistProgressInitialized) return;
  window.__jrbMinimalistProgressInitialized = true;

  const selector = '[data-jrb-minimalist-countdown]';
  const roots = new Set();
  let intervalId = null;

  function update(root, now) {
    if (!root.isConnected) {
      roots.delete(root);
      return;
    }
    const bar = root.querySelector('.progress-container-1');
    if (!bar) return;
    const timer = root.querySelector('countdown-timer');
    const target = Number.isFinite(timer && timer.countDownDate)
      ? timer.countDownDate
      : Number(root.dataset.timerTargetMs);
    const rawWindow = Number(root.dataset.progressWindowMs);
    const duration = Number.isFinite(rawWindow) && rawWindow > 0 ? rawWindow : 345600000;
    if (!Number.isFinite(target) || target <= 0) return;

    const percent = Math.max(0, Math.min(100, (1 - (target - now) / duration) * 100));
    const percentText = percent.toFixed(3);
    const fill = bar.querySelector('.progress1');
    if (fill && fill.dataset.progressPercent !== percentText) {
      fill.style.width = percentText + '%';
      fill.dataset.progressPercent = percentText;
    }
    const rounded = String(Math.round(percent));
    if (bar.getAttribute('aria-valuenow') !== rounded) bar.setAttribute('aria-valuenow', rounded);
  }

  function tick() {
    const now = Date.now();
    roots.forEach(function (root) {
      update(root, now);
    });
    if (!roots.size) stop();
  }

  function stop() {
    if (intervalId !== null) window.clearInterval(intervalId);
    intervalId = null;
  }

  function start() {
    if (intervalId !== null || document.hidden || !roots.size) return;
    intervalId = window.setInterval(tick, 1000);
  }

  function scan(scope) {
    const found = scope.matches && scope.matches(selector) ? [scope] : [];
    if (scope.querySelectorAll) scope.querySelectorAll(selector).forEach(function (node) { found.push(node); });
    found.forEach(function (node) { roots.add(node); });
    tick();
    start();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); }, { once: true });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:unload', tick);
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) stop();
    else { tick(); start(); }
  });
})();